<template>
  <v-dialog persistent v-model="value" max-width="1300px" scrollable>
    <v-card>
      <v-toolbar dark color="gradiente">
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Detalle del pago</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :disabled="flags.loading" dark flat @click="update">Actualizar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid style="max-height: 93vh;" class="scrollDesign">
        <v-layout row wrap justify-space-between>
          <v-flex xs12 md6 lg5>
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  label="Nombre del pago"
                  :value="payment ? payment.name : ''"
                  v-model="paymentForm.name"
                  name="name"
                  prepend-icon="title"
                  :error-messages="nameErrors"
                  rows="1"
                  row-height="24"
                  auto-grow
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <DateTimePicker
                  :errorMessages="dueDateErrors"
                  v-model="paymentForm.dueDate"
                  titleDate="Fecha límite"
                  titleTime="Hora límite"
                ></DateTimePicker>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-checkbox
                  color="primary"
                  id="split"
                  v-model="paymentForm.split"
                  label="Dividir pago entre padres"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-checkbox
                  color="primary"
                  id="apply"
                  v-model="paymentForm.apply"
                  label="Publicar pago"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg4>
            <v-list>
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-icon class="red--text">account_circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Creador</v-list-tile-title>
                  <v-list-tile-sub-title
                    v-if="payment && payment.user"
                  >{{payment.user.firstName}} {{payment.user.lastName}}</v-list-tile-sub-title>
                  <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-icon class="red--text">work</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Concepto</v-list-tile-title>
                  <v-list-tile-sub-title v-if="payment">{{ payment.concept.name }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-icon class="red--text">monetization_on</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Monto</v-list-tile-title>
                  <v-list-tile-sub-title
                    v-if="payment"
                  >{{ payment.concept.amount | formatCurrency }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
          <v-flex xs12 md6 lg2>
            <v-img :src="require('@/assets/payments/SKLB-Pagos.png')"></v-img>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
 
<script>
import DateTimePicker from "../Sections/Notices/Tools/DateTimePicker2";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    DateTimePicker,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    payment: {
      type: Object,
      required: false,
    },
  },
  filters: {},
  validations: {
    paymentForm: {
      name: { required },
      dueDate: { required },
    },
  },
  data: () => ({
    paymentForm: {
      name: "",
      dueDate: "",
      split: false,
      apply: false,
    },
    flags: {
      loading: false,
    },
  }),
  watch: {
    payment() {
      if (!this.payment) return;

      this.paymentForm = {
        name: this.payment.name,
        dueDate: new Date(this.payment.dueDate),
        split: this.payment.metadata.split,
        
      };
    },
  },
  methods: {
    close() {
      this.$emit("onClosed");
    },
    update() {
      this.$v.paymentForm.$touch();
      if (this.$v.paymentForm.$invalid) return;

      this.flags.loading = true;
      var request = {
        name: this.paymentForm.name,
        dueDate: this.paymentForm.dueDate.getTime(),
        split: this.paymentForm.split,
        apply: this.paymentForm.apply,
      };

      this.$store
        .dispatch("payments/updatePayment", {
          id: this.payment.id,
          request: request,
        })
        .then((response) => {
          this.flags.loading = false;
          this.$emit("onUpdated", { success: true, payment: response.data });
        })
        .catch((error) => {
          this.flags.loading = false;
          this.$emit("onUpdated", { success: false, error: error });
        });
    },
  },
  computed: {
    nameErrors() {
      if (this.$v.paymentForm.name.$dirty && !this.$v.paymentForm.name.$model) {
        return ["Nombre requerido"];
      }
      return [];
    },
    dueDateErrors() {
      if (this.$v.paymentForm.dueDate.$dirty && !this.$v.paymentForm.dueDate.$model) {
        return ["Fecha límite requerida"];
      }
      return [];
    },
  },
};
</script>

<style>
</style>
